import {normalizeBulkVosTimeForApi} from './bulkVosClientPortalFormat'

export type BatchItemAdjust = {
  originalStartTime?: string
  originalEndTime?: string
  originalMilage?: number
  originalTravelTimeH?: number
  originalTravelTimeM?: number
  editableStartTime?: string
  editableEndTime?: string
  editableMilage?: number
  editableTravelTimeH?: number
  editableTravelTimeM?: number
  remarks?: string
}

export type BatchItem = {
  id: number
  batchId: number
  appointmentCode?: number
  osiSubmissionCode?: number
  vosSubmissionMode?: number
  callId?: string
  requesterName?: string
  recordId?: string
  interpreterId?: string
  assignmentDate?: string
  startTime?: string
  endTime?: string
  duration?: string
  remarks?: string
  communicationTypeLabel?: string
  isDisputed: boolean
  financeStatus?: number
  adjust?: BatchItemAdjust
}

export type BatchDetail = {
  batchId: number
  customerId: number
  customerName?: string
  status: number
  createdAt?: string
  submittedAt?: string
  portalToken?: string
  tokenExpiresAt?: string
  servicePeriodStartUtc?: string
  servicePeriodEndUtc?: string
  items: BatchItem[]
}

export type ItemDraft = BatchItemAdjust

export function defaultDraftFromItem(item: BatchItem): ItemDraft {
  const a = item.adjust
  return {
    originalStartTime: a?.originalStartTime,
    originalEndTime: a?.originalEndTime,
    originalMilage: a?.originalMilage,
    originalTravelTimeH: a?.originalTravelTimeH,
    originalTravelTimeM: a?.originalTravelTimeM,
    editableStartTime: a?.editableStartTime ?? a?.originalStartTime ?? item.startTime,
    editableEndTime: a?.editableEndTime ?? a?.originalEndTime ?? item.endTime,
    editableMilage: a?.editableMilage ?? a?.originalMilage,
    editableTravelTimeH: a?.editableTravelTimeH ?? a?.originalTravelTimeH,
    editableTravelTimeM: a?.editableTravelTimeM ?? a?.originalTravelTimeM,
    remarks: a?.remarks ?? item.remarks ?? '',
  }
}

export function disputeDraftPayload(draft: ItemDraft | undefined, cancelDispute: boolean) {
  return {
    isDisputed: !cancelDispute,
    clientStartTime: normalizeBulkVosTimeForApi(draft?.editableStartTime),
    clientEndTime: normalizeBulkVosTimeForApi(draft?.editableEndTime),
    clientMilage: draft?.editableMilage,
    clientTravelTimeH: draft?.editableTravelTimeH,
    clientTravelTimeM: draft?.editableTravelTimeM,
    clientRemarks: draft?.remarks,
  }
}

export function financePatchPayload(draft: ItemDraft | undefined, cancelDispute: boolean) {
  return {
    financeStartTime: normalizeBulkVosTimeForApi(draft?.editableStartTime),
    financeEndTime: normalizeBulkVosTimeForApi(draft?.editableEndTime),
    financeMilage: draft?.editableMilage,
    financeTravelTimeH: draft?.editableTravelTimeH,
    financeTravelTimeM: draft?.editableTravelTimeM,
    financeRemarks: draft?.remarks,
    markHandled: !cancelDispute,
  }
}
